import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import logo from "../../../../assets/logo.png";
import { MenuWrapper,Socialimg,DesktopMainMenu, MaterialUISwitch, MenuLink } from "../styles";
import { toggleTheme } from '../../../../Redux/switchTheme'
import { useDispatch, useSelector } from "react-redux";

const DesktopMenu = (props) => {
  const currentTheme = useSelector( (state) => state.LDTheme.value )
  const dispatch = useDispatch();
 
  return (
    <DesktopMainMenu maxWidth="xl">
      <MenuLink style={{display:"flex",justifyContent:"center"}} href="/" p="0px">
        <img src={logo} width="180" height='auto' alt="Logo" />
      </MenuLink>
      <MenuWrapper>
        {props.menuList.map((value, i) => <MenuLink key={i} href={value.link} target={value.target} className={value.customClass}>{value.title}</MenuLink> )}
        <a href="https://twitter.com/luffycoineth" target='blank' style={{display:"flex",justifyContent:"center"}}><Socialimg src="./assets/twitter.png" alt="" /></a>
        <a href="https://t.me/luffycoineth" target='blank' style={{display:"flex",justifyContent:"center"}}><Socialimg src="./assets/tele.png" alt="" /></a>
        {/* <FormControlLabel
          control={
            <MaterialUISwitch 
              sx={{ m: 1 }} 
              checked={currentTheme}
            />
          }
          onClick={() => dispatch(toggleTheme())}
        /> */}
      </MenuWrapper>
    </DesktopMainMenu>
  );
};

export default DesktopMenu;
